import React from "react";
import { useHistory } from "react-router-dom";
import { Aside, EditButton, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../../../../core/security/SprintAccessRight";
import { AssetCreationWarning } from "../../../../../../common/components/AssetCreationWarning";
import { isCloudAssetDeprecated } from "../../../../../CloudAssetDetails";
import { useCloudAssetDetails } from "../../../../../common/hooks/useCloudAssetDetails";
import { resolveCloudAssetHref } from "../../../common/resolveCloudAssetHref";
import { CloudAudioAssetLanguageForm } from "./CloudAudioAssetLanguageForm";

export interface EditCloudAudioAssetButtonAsideProps {
    isLabeled?: boolean;
    soundtrackId: string;
}

export const EditCloudAudioAssetButtonAside: React.FunctionComponent<EditCloudAudioAssetButtonAsideProps> = (
    props: EditCloudAudioAssetButtonAsideProps
) => {
    const { isLabeled, soundtrackId } = props;

    const { isOpen, onOpen, onClose } = useDisclosure();

    const { isLoading, data: assetDetails } = useCloudAssetDetails();

    const history = useHistory();

    const onSubmit = (newAssetId: string) => {
        if (!assetDetails) {
            return;
        }

        const newHref = resolveCloudAssetHref(assetDetails.content.subtype, newAssetId);
        history.push(newHref);
        onClose();
    };

    const areActionsDisabled = assetDetails && (isCloudAssetDeprecated(assetDetails) || isLoading);

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.AssetsReadWrite]}>
            <EditButton
                onClick={onOpen}
                isLabeled={isLabeled}
                label="Edit"
                disabled={areActionsDisabled}
                testId="edit-soundtrack"
            />
            <Aside type="form" headerText="Edit soundtrack" isOpen={isOpen} onDismiss={onClose} isLightDismiss={true}>
                <AssetCreationWarning />
                <CloudAudioAssetLanguageForm onDismiss={onClose} onSubmit={onSubmit} soundtrackId={soundtrackId} />
            </Aside>
        </AuthorizationWrapper>
    );
};
